module.exports = __webpack_public_path__ + "img/钳制机械臂v2.865b55f0.png";